import { useMemo } from 'react'

import { ROLES } from '../../common/constants'

import { useLoggedInUser, useUserHasRoles } from '../../account/hooks'

const useUserHasUnknownWordChangePermission = (
  menuCurationTask,
  unknownWord,
) => {
  const { id: currentUserId } = useLoggedInUser()

  const userCanEditAnyTask = useUserHasRoles([
    ROLES.ADMIN.value,
    ROLES.GUILD_LEAD.value,
  ])
  const { assignedUnknownWordsCurator, assignedUnknownWordsQa } =
    menuCurationTask || {}

  const isUserUnknownWordsCurator = useMemo(
    () => assignedUnknownWordsCurator?.id === currentUserId,
    [assignedUnknownWordsCurator?.id, currentUserId],
  )

  const isUserUnknownWordsQa = useMemo(
    () => assignedUnknownWordsQa?.id === currentUserId,
    [assignedUnknownWordsQa?.id, currentUserId],
  )

  if (userCanEditAnyTask) {
    return {
      userHasChangePermission: true,
    }
  }

  if (isUserUnknownWordsCurator && !unknownWord.isCurationDone) {
    return {
      userHasChangePermission: true,
    }
  }

  if (isUserUnknownWordsQa && unknownWord.isCurationDone) {
    return {
      userHasChangePermission: true,
    }
  }

  return {
    userHasChangePermission: false,
  }
}

export default useUserHasUnknownWordChangePermission
